((Drupal) => {
  Drupal.behaviors.nrwSaveSearch = {
    attach: (context) => {

      once('NRWgenerateLink', '#saveSearchBtn', context).forEach( ($element) => {

        let $url = (new URL(document.location));
        let $params = new URLSearchParams($url.search);
        let $search = $params.get('search');

        if ($params.size > 0) {
          $element.classList.remove('d-none');
        }

        $element.addEventListener('click', ($event) => {
          $event.preventDefault();
          let $identStr = '_64_';

          if ($search.startsWith($identStr)) {
            $search = window.atob($search.replace($identStr, ''));
          }
          $params.set('search', $identStr + window.btoa($search));
          document.getElementById('linkSaveLink').value = $url.origin + $url.pathname + '?' + $params.toString();
        });
      });

      once('NRWsaveLink', '#linkSaveBtn', context).forEach( ($element) => {
        $element.addEventListener('click', ($event) => {

          $event.preventDefault();
          let $textToCopy = document.getElementById('linkSaveLink').value;

            window.navigator.clipboard.writeText($textToCopy).then(
              function () {
                // Clipboard successfully set
                const $tooltip = bootstrap.Tooltip.getOrCreateInstance('#linkSaveBtn')
                $tooltip.show()
                // setTimeout(
                //    () => {
                //     $tooltip.hide()
                //   }, 800);

              },
              function () {
                // Clipboard write failed
                window.alert('Opps! Your browser does not support the Clipboard API')
              }
            );
        });
      });
    },
  };
})(Drupal);
